export const OrderByPosition = (a: any, b: any): number => {
  return a.value.position > b.value.position ? 1 : b.value.position > a.value.position ? -1 : 0;
};
